import { render, staticRenderFns } from "./intelligence.vue?vue&type=template&id=db27dbe0&"
import script from "./intelligence.vue?vue&type=script&lang=js&"
export * from "./intelligence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports